// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__sVPr2","hidden":"Modal_hidden__ygMTp","modal_dialog":"Modal_modal_dialog__y294h","modal_content":"Modal_modal_content__vVRqm"};